import { useQuery, UseQueryResult } from 'react-query';
import { PaymentMethodRetrieve } from 'types';
import { NonStripePaymentMethod } from 'types/enums';
import { client } from 'utils/api-client';

function usePaymentMethod(
  paymentMethodId: string | undefined,
): UseQueryResult<{ data: PaymentMethodRetrieve }> {
  const isNonStripePaymentMethod = Object.values(NonStripePaymentMethod).includes(
    paymentMethodId as NonStripePaymentMethod,
  );

  return useQuery(
    ['paymentMethods', paymentMethodId],
    () => client.get(`payment-methods/${paymentMethodId}/`),
    {
      enabled: !!paymentMethodId && !isNonStripePaymentMethod,
    },
  );
}

export default usePaymentMethod;
